import { render } from "./pageH5.vue?vue&type=template&id=335390ce&scoped=true"
import script from "./pageH5.vue?vue&type=script&lang=js"
export * from "./pageH5.vue?vue&type=script&lang=js"

import "./pageH5.vue?vue&type=style&index=0&id=335390ce&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335390ce"]])

export default __exports__